import { useCallback } from 'react';

export type Event =
  | 'purchase'
  | 'user_data'
  | 'sign_up'
  | 'checkout_started'
  | 'subscription_canceled'
  | 'subscription_downgraded'
  | 'add_project'
  | 'login_successful'
  | 'first_results_viewed';

export interface IDataLayer {
  event: Event;
}

export interface IProjectDataLayer extends IDataLayer {
  event: Event;
  project_id: string;
  email_hashed: string;
  user_id: string;
  account_id: string;
}

export interface IDefaultDataLayer extends IDataLayer {
  event: Event;
  email_hashed: string;
  user_id: string;
  account_id: string;
}

export interface ILoginDataLayer extends IDataLayer {
  event: Event;
  email_hashed: string;
  user_id: string;
}

export interface IDowngradedDataLayer extends IDataLayer {
  event: Event;
  email_hashed: string;
  new_plan: string;
  user_id: string;
  account_id: string;
}

export interface ISignUpDataLayer extends IDataLayer {
  event: Event;
  email_hashed: string;
  user_id: string;
  account_type: string;
}

export interface IPurchaseDataLayer extends IDataLayer {
  event: Event;
  transaction_id: string;
  value: number;
  currency: string;
  user_id: string;
  account_id: string;
  items: {
    item_id: string;
    item_name: string;
    price: number;
    quantity: number;
  }[];
}

export interface IUserDataDataLayer extends IDataLayer {
  event: Event;
  email_hashed: string;
  user_id: string;
  account_id: string;
  account_type: string;
}

const useDataLayer = () => {
  const pushDataLayer = useCallback(<T extends IDataLayer>(arg: T) => {
    try {
      (window as any).dataLayer.push(arg);
    } catch (error) {
      console.error(error);
    }
  }, []);

  return {
    pushDataLayer,
  };
};

export default useDataLayer;
